import { ValidationFunctionResult } from '../../../../shared/types/validation-function-result';
import { UpdateProtoSettingsDto } from '../../dtos/update-proto-settings.dto';

/**
 * Validates settings record data for update.
 * @param settings - The settings record to validate.
 * @param abortEarly - Whether to abort the validation on the first error.
 * @returns The validation result.
 */
export const canUpdate = (
	settings: UpdateProtoSettingsDto,
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	abortEarly: boolean = false,
): ValidationFunctionResult => {
	// Check
	if (!settings) throw new Error('Settings is required');

	// // Validate
	// const { error } = update....Schema().validate(record, {
	// 	abortEarly,
	// });

	// // Check
	// if (error) {
	// 	return {
	// 		isValid: false,
	// 		errors: error.details?.map((e) => e.message),
	// 	};
	// }

	// Return
	return { isValid: true };
};
